import { render, staticRenderFns } from "./specialImg_list.vue?vue&type=template&id=15842aac"
import script from "./specialImg_list.vue?vue&type=script&lang=js"
export * from "./specialImg_list.vue?vue&type=script&lang=js"
import style0 from "./specialImg_list.vue?vue&type=style&index=0&id=15842aac&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports